const BrowserFS = require('browserfs')

module.exports = BrowserFS.BFSRequire('fs')
